<template>
    <div class="bg th ba b--light-gray" :style="backgroundStyle">
        <flat-pickr :config="config" :value="value" @input="onDateChange($event)"></flat-pickr>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data: function() {
        return {
            config: {
                altInput: true,
                altFormat: 'M j, Y'
            }
        };
    },
    components: {
        flatPickr
    },
    props: {
        imageUrl: {
            type: String
        },
        value: {
            type: String
        }
    },
    computed: {
        backgroundStyle() {
            return this.imageUrl
                ? { 'background-image': `url(${this.imageUrl})` }
                : null;
        }
    },
    methods: {
        onDateChange(date) {
            this.$emit('input', date);
        }
    }
};
</script>

<style scoped>
.bg {
    background-repeat: no-repeat;
    background-position: 10px center;
}
</style>

<style>
.flatpickr-input {
    width: 100%;
    height: 100%;
    border: none;
    background: transparent;
    padding-left: 40px;
}

.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
    background: #fb0;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #fff;
    border-color: #fb0;
}
</style>
